module.exports = __webpack_public_path__ + "img/speakeasy.5a1524d4.jpg";